<template>
  <v-col cols="12" class="d-flex flex-row justify-space-between align-center">
    <h2>
      {{ title }}
    </h2>
    <slot></slot>
  </v-col>
</template>

<script>
export default {
  name: "ViewHeader",
  props: {
    title: {
      type: [String, Object],
      default: ""
    }
  }
};
</script>

<style lang="scss" scoped>
.view-header__title {
  @include font-size(24px);
  color: $grey-darker;
  font-weight: bold;
  text-transform: uppercase;
}
</style>
